'use client';

import { HTTPError } from 'ky';
import { metadataApi } from '../api/endpoints';
import type { TagsData } from '../api/types';
import { useCustomQuery } from '../query/useCustomQuery';
export const metadataQueryKeys = {
  metadata: (key: string) => ['metadata', key] as const
};
export function useMetadata<T>(key: string, options?: {
  enabled?: boolean;
}) {
  return useCustomQuery({
    queryKey: metadataQueryKeys.metadata(key),
    queryFn: async () => {
      try {
        const response = await metadataApi.getMetadata<T>(key);
        return response.data ?? null;
      } catch (error) {
        // A missing metadata key is a valid state, not a failure. Resolving with null
        // keeps the query in a settled `success` state so consumers stop flipping back
        // into `isLoading` (and remounting) on every retry/refetch.
        if (error instanceof HTTPError && error.response.status === 404) {
          return null;
        }
        throw error;
      }
    },
    staleTime: 1000 * 60 * 60,
    // 1 hour
    ...options
  });
}
export function useItemTags() {
  return useMetadata("item_tags");
}